import useFeatureMap from '@/hooks/useFeatureMap';

export function useIntakeCareLocation() {
  const { noEpisodeOfCare } = useFeatureMap();
  const isCareLocationEnabled = !noEpisodeOfCare;

  return {
    isCareLocationEnabled,
    getSubmittedCareLocation(careLocation?: string | null) {
      return isCareLocationEnabled ? careLocation : undefined;
    },
  };
}
